export interface iAdminRibbon__API {
    'id': number;
    'name': string | null;
    'isActive': boolean;
    'publicationIds': number[] | null;
}

export interface iArticleAdmin__API {
    'id': number;
    'title': string | null;
    'description': string | null;
    'tagsIds': number[] | null;
    'tags'?: iTagShort__API[] | null;
    'numberOfPages': number;
    'minutesToRead': number;
    'bigImageName'?: string | null;
    'featuredContentImageName'?: string | null;
    'files': iFile__API[] | null;
}

export interface iArticleReference__API {
    'id'?: number;
    'title': string | null;
    'imageUrl': string | null;
    'hasAccess': boolean;
    'files': iFile__API[] | null;
    'createDate': string | null;
    'publicationType': DocumentType;
}

export interface iButtonCategory__API {
    'titleCategories'?: iTitleCategory__API[] | null;
    'buttonCategories'?: iTitleCategory__API[] | null;
}

export interface iChapterAdmin__API {
    'publicationId': number;
    'pageFrom': number;
    'pageTo': number;
    'id': number;
    'title': string | null;
    'description': string | null;
    'tagsIds': number[] | null;
    'tags'?: iTagShort__API[] | null;
    'numberOfPages': number;
    'minutesToRead': number;
    'bigImageName'?: string | null;
    'featuredContentImageName'?: string | null;
    'files': iFile__API[] | null;
}

export interface ChatBotCitation {
    'articleId'?: number;
    'pageNumber'?: number;
    'date'?: string;
}

export interface iCompaniesWithUsers__API {
    'companies'?: number[] | null;
    'users'?: string[] | null;
}

export interface ContentWatchDto {
    'frequency'?: FrequencyEnum;
    'isEverything'?: boolean;
    'userOnlySubscriptionPackage'?: boolean;
    'subscriptionPackages'?: number[] | null;
    'tags'?: number[] | null;
    'isDailyDishEnabled'?: boolean | null;
    'isNewsArticleEnabled'?: boolean | null;
}

export interface ContentWatchEmailModel {
    'emailTo': string | null;
    'userFirstName': string | null;
    'tags': string[] | null;
    'userOnlySubscriptionPackage': boolean;
    'publications': ContentWatchEmailPublicationModel[] | null;
    'companyId': number | null;
    'userId'?: number;
    'contentWatchLink'?: string | null;
}

export interface ContentWatchEmailPublicationModel {
    'id': number;
    'image': string | null;
    'name': string | null;
    'description': string | null;
    'link': string | null;
}

export const DocumentType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type DocumentType = typeof DocumentType[keyof typeof DocumentType];
export interface ElasticSuggest {
    'contexts'?: any;
    'input'?: string[] | null;
    'weight'?: number;
}

export interface iFile__API {
    'filename': string | null;
    'type': string | null;
}

export const FrequencyEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type FrequencyEnum = typeof FrequencyEnum[keyof typeof FrequencyEnum];
export interface GetAllWithFilterModel {
    'ribbonsIds'?: number[] | null;
    'categoriesIds'?: number[] | null;
    'includeAnySubscriptionPackageIds'?: number[] | null;
    'includeAllSubscriptionPackageIds'?: number[] | null;
    'includeAnyTagsIds'?: number[] | null;
    'includeAllTagsIds'?: number[] | null;
    'types'?: DocumentType[] | null;
    'searchText'?: string | null;
    'skip'?: number;
    'take'?: number;
    'orderBy'?: string | null;
    'sortOrder'?: string | null;
    'hasAccess'?: boolean;
}

export interface GetLatestNewsAndPublicationsRequest {
    'count'?: number;
    'periodInDays'?: number;
    'tags'?: number[] | null;
}

export interface IdNameModel {
    'id'?: number;
    'name'?: string | null;
}

export const ImageType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type ImageType = typeof ImageType[keyof typeof ImageType];
export interface LatestNewsAndPublication {
    'publications'?: iPublicationClient__API[] | null;
    'news'?: RecentNewsArticleModel[] | null;
}

export interface iMacSnapLight__API {
    'id'?: number;
    'title'?: string | null;
    'createDate'?: string | null;
    'updateDate'?: string | null;
    'bigImageName'?: string | null;
}

export interface NewsArticleDetail {
    'content'?: string | null;
    'publishedDate'?: string | null;
    'tags'?: string[] | null;
    'id'?: number;
    'featuredImage': string | null;
    'title': string | null;
    'description': string | null;
}

export interface NewsArticleFilter {
    'tags'?: number[] | null;
    'searchTerm'?: string | null;
    'sortOrder'?: string | null;
    'orderBy'?: string | null;
    'skip'?: number;
    'take'?: number;
}

export interface NewsArticleLikeDislikeRequest {
    'newsArticleId': number;
    'isLiked': boolean;
}

export interface NewsArticleModel {
    'publishedDate': string;
    'type': string | null;
    'tags'?: string[] | null;
    'content': string | null;
    'referenceArticles'?: number[] | null;
    'id'?: number;
    'featuredImage': string | null;
    'title': string | null;
    'description': string | null;
}

export interface iPublicationAdmin__API {
    'price'?: number | null;
    'isPublished'?: boolean;
    'isTesting'?: boolean;
    'createDate': string | null;
    'buttonCategoryId'?: number;
    'titleCategoryId'?: number;
    'chapters'?: iChapterAdmin__API[] | null;
    'subscriptionPackageIds': number[] | null;
    'tags'?: iTagShort__API[] | null;
    'id': number;
    'title': string | null;
    'description': string | null;
    'tagsIds': number[] | null;
    'numberOfPages': number;
    'minutesToRead': number;
    'bigImageName'?: string | null;
    'featuredContentImageName'?: string | null;
    'files': iFile__API[] | null;
}

export interface iPublicationBase__API {
    'id': number;
    'title': string | null;
    'snapDocumentId': number;
    'createdDate': string | null;
}

export interface iPublicationClientDetail__API {
    'publication': iPublicationClient__API;
    'relatedPublications': iPublicationClient__API[] | null;
}

export interface iPublicationClient__API {
    'bigImageUrl': string | null;
    'featuredContentImageUrl': string | null;
    'price': number | null;
    'createDate': string | null;
    'updateDate': string | null;
    'buttonCategoryId': number;
    'titleCategoryId': number;
    'chapters': iPublicationClient__API[] | null;
    'publicationId': number;
    'pageFrom': number;
    'pageTo': number;
    'hasChapters'?: boolean;
    'publicationTitle': string | null;
    'score'?: number;
    'isPublished'?: boolean;
    'subscriptionPackages'?: iSubscriptionPackage__API[] | null;
    'type'?: string | null;
    'pageNumber'?: number;
    'pages'?: number[] | null;
    'updateDateToOrder'?: string | null;
    'id'?: number;
    'title': string | null;
    'description': string | null;
    'imageUrl': string | null;
    'tags': iTagShort__API[] | null;
    'numberOfPages': number;
    'minutesToRead': number;
    'isLiked': boolean;
    'isShared': boolean;
    'isAddedToReadingList': boolean;
    'hasAccess': boolean;
    'publicationType': DocumentType;
    'files': iFile__API[] | null;
    'createDateToOrder'?: string;
}

export interface iPublicationClientWrapper__API {
    'data'?: iPublicationClient__API[] | null;
}

export interface iPublicationInfo__API {
    'id'?: number;
    'title'?: string | null;
    'buttonCategoryName'?: string | null;
    'titleCategoryName'?: string | null;
    'buttonCategoryId'?: number;
    'titleCategoryId'?: number;
    'featureIds'?: number[] | null;
    'createDate'?: string;
}

export interface iPublicationShort__API {
    'id': number;
    'title': string | null;
    'createDate': string | null;
    'titleCategoryName': string | null;
    'subscriptionPackageIds'?: number[] | null;
}

export interface iPublication__API {
    'chapterCount': number;
    'chapters': iPublicationBase__API[] | null;
    'titleCategoryName': string | null;
    'buttonCategoryName': string | null;
    'id': number;
    'title': string | null;
    'snapDocumentId': number;
    'createdDate': string | null;
}

export interface iPublicationsBlock__API {
    'items'?: iPublicationClient__API[] | null;
    'totalCount'?: number;
    'answer'?: string | null;
}

export interface RecentNewsArticleModel {
    'publishedDate'?: string;
    'type'?: number;
    'isFeatured'?: boolean;
    'recordType'?: number;
    'parentNewsArticleId'?: number | null;
    'id'?: number;
    'featuredImage': string | null;
    'title': string | null;
    'description': string | null;
}

export interface iRibbon__API {
    'id': number;
    'name': string | null;
    'isActive': boolean;
    'publications': iPublicationClient__API[] | null;
}

export interface SearchMacForEachLNRCategoryRequest {
    'categories'?: IdNameModel[] | null;
    'count'?: number;
}

export interface iSearchMacs__API {
    'macsResults'?: iPublicationClient__API[] | null;
    'macsResultsCount'?: number;
}

export interface SearchRequestModel {
    'query'?: string | null;
    'inMyLibrary'?: boolean;
    'skipDocs'?: number;
    'takeDocs'?: number;
    'skipMacs'?: number;
    'takeMacs'?: number;
    'simpleSearch'?: boolean;
}

export interface iSearch__API {
    'generatedText'?: string | null;
    'statusCode'?: number;
    'macsResults'?: iPublicationClient__API[] | null;
    'documentsResults'?: iPublicationClient__API[] | null;
    'macsResultsCount'?: number;
    'otherResultsCount'?: number;
}

export interface iSearchWithChatBot__API {
    'generatedText'?: string | null;
    'citations'?: ChatBotCitation[] | null;
    'macsResults'?: iPublicationClient__API[] | null;
    'documentsResults'?: iPublicationClient__API[] | null;
    'chatBotResultsCount'?: number;
    'macsResultsCount'?: number;
    'otherResultsCount'?: number;
}

export interface iSharePublication__API {
    'users'?: iSnapUser__API[] | null;
    'message': string | null;
}

export interface SnapElasticDocument {
    'documentType'?: number;
    'featureId'?: number;
    'price'?: number;
    'companiesIds'?: number[] | null;
    'isPrivate'?: boolean;
    'modifiedByUser'?: string | null;
    'modifiedDate'?: string | null;
    'phase'?: number;
    'isArchived'?: boolean;
    'canPurchase'?: boolean;
    'hidden'?: boolean;
    'databaseId'?: number;
    'date'?: string | null;
    'dateTime'?: string | null;
    'description'?: string | null;
    'fileExtention'?: string | null;
    'fileSize'?: number;
    'fileName'?: string | null;
    'id'?: number;
    'instanceId'?: number;
    'pages'?: number;
    'parentId'?: number;
    'parentGuid'?: string | null;
    'parentPages'?: number;
    'projectsJson'?: string | null;
    'publicationFamily'?: string | null;
    'sampleFile'?: string | null;
    'title'?: string | null;
    'categoryId'?: number;
    'penetration'?: number;
    'chainId'?: number;
    'publicationFamilyBoost'?: number;
    'suggest'?: ElasticSuggest[] | null;
    'lastUpdateDateTime'?: string | null;
}

export interface iSnapGroup__API {
    'id'?: number;
    'name'?: string | null;
    'users'?: string[] | null;
}

export interface iSnapPublication__API {
    'chapterCount': number;
    'chapters': iPublicationBase__API[] | null;
    'publicationFamily': string | null;
    'id': number;
    'title': string | null;
    'snapDocumentId': number;
    'createdDate': string | null;
}

export interface iSnapUser__API {
    'id': string;
    'email': string | null;
    'firstName': string | null;
    'lastName': string | null;
    'showOnboardingScreens': boolean;
    'companyName': string | null;
    'companyId': number;
    'isInMyLibraryToggledOn': boolean;
    'isAdmin': boolean;
    'aiSearchEnabled'?: boolean;
    'globalSubscriptionPackageIds'?: number[] | null;
    'globalAssociatedRibbonsIds'?: number[] | null;
}

export interface iSubscriptionPackage__API {
    'id': number;
    'name': string | null;
}

export interface iTagShort__API {
    'id': number;
    'value': string | null;
}

export interface iTag__API {
    'publicationsIds'?: number[] | null;
    'isAvailableForNews'?: boolean;
    'definition'?: string | null;
    'id': number;
    'value': string | null;
}

export interface TestEmail {
    'emailBcc'?: string | null;
    'html'?: string | null;
}

export interface iTitleCategory__API {
    'id': number;
    'name': string | null;
}

export interface iUserAccessRequest__API {
    'firstName': string | null;
    'lastName': string | null;
    'companyName': string | null;
    'articleId': number;
    'articleTitle': string | null;
    'userId': number;
    'documentType': DocumentType;
    'titleCategoryName': string | null;
    'packages': string | null;
    'email': string | null;
}
